<!--
<template>
  <div id="app">
    <FloatingMenu />
    <router-view />
  </div>
</template>

<script setup>
import FloatingMenu from './components/FloatingMenu.vue'
</script>-->


<!--new language-->

<template>
  <div id="app">
    <header class="language-switcher" aria-label="Language selector">
      <div class="language-switcher__controls" role="group" aria-label="Choose language">
        <button
          type="button"
          class="language-switcher__button"
          :class="{ 'language-switcher__button--active': locale === 'id' }"
          :aria-pressed="locale === 'id'"
          @click="setLocale('id')"
        >
          ID
        </button>

        <button
          type="button"
          class="language-switcher__button"
          :class="{ 'language-switcher__button--active': locale === 'en' }"
          :aria-pressed="locale === 'en'"
          @click="setLocale('en')"
        >
          EN
        </button>
      </div>
    </header>

    <FloatingMenu />
    <router-view />
  </div>
</template>

<script setup>
import FloatingMenu from './components/FloatingMenu.vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

function setLocale(lang) {
  locale.value = lang
  localStorage.setItem('locale', lang)
}
</script>

<style scoped>
.language-switcher {
  --brand-blue: #084e8b;
  --brand-orange: #f15a24;
  --panel-bg: rgba(255, 255, 255, 0.9);
  --panel-border: rgba(8, 78, 139, 0.16);

  position: fixed;
  top: clamp(12px, 2vw, 20px);
  right: clamp(12px, 2vw, 20px);
  z-index: 9999;
  display: flex;
  align-items: center;
  padding: 6px;
  border: 1px solid var(--panel-border);
  border-radius: 999px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(237, 244, 249, 0.88)),
    var(--panel-bg);
  box-shadow: 0 18px 40px rgba(6, 55, 97, 0.14);
  backdrop-filter: blur(14px);
}

.language-switcher__controls {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  border-radius: 999px;
  background: rgba(8, 78, 139, 0.08);
}

.language-switcher__button {
  min-width: 44px;
  border: 0;
  border-radius: 999px;
  padding: 7px 10px;
  background: transparent;
  color: rgba(6, 55, 97, 0.72);
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}

.language-switcher__button:hover {
  transform: translateY(-1px);
  color: var(--brand-blue);
}

.language-switcher__button:focus-visible {
  outline: 2px solid var(--brand-orange);
  outline-offset: 2px;
}

.language-switcher__button--active {
  background: linear-gradient(135deg, var(--brand-blue), #0b68ba);
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(8, 78, 139, 0.24);
}

@media (max-width: 640px) {
  .language-switcher {
    padding: 5px;
  }

  .language-switcher__button {
    min-width: 42px;
    padding: 6px 9px;
  }
}
</style>
